const doc = [({"en":({"js":({"admin":({"agenda_item_element_speakers":({"table":({"speakers":"Speakers"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;